import React from "react";

const PaymentClose = ({ onClose }) => {
  return (
    <button
      className="mt-5 px-5 py-2 w-1/4 rounded-lg bg-custom-dodger-blue-300 font-bold"
      onClick={onClose}
    >
      Close
    </button>
  );
};

export default PaymentClose;
